<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1">Personen</h1>
<p class="calibre2"></p>
<h2 class="title" id="calibre_pb_0">Agamemnon</h2>
<p class="calibre2"></p>
<p class="calibre3"><b class="calibre4">Wächter</b><br class="calibre5"/>
<b class="calibre4">Klytaimestra</b><br class="calibre5"/>
<b class="calibre4">Herold</b><br class="calibre5"/>
<b class="calibre4">Agamemnon</b><br class="calibre5"/>
<b class="calibre4">Kassandra</b><br class="calibre5"/>
<b class="calibre4">Aigisthos</b><br class="calibre5"/>
<b class="calibre4">Chor argivischer Greise</b></p>
<p class="calibre2"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0_split_000.vue?392ef640